<template>
  <div class="history-record">
    <div class="record-item" v-for="subItem in showList" :key="subItem.id" @click="toUrl(subItem)">
      <div>
        <div class="record-name txt-ellipsis">{{ subItem.detailName }}</div>
        <div class="total-num" v-if="![-1, 1].includes(subItem.status) && ![3].includes(subItem.orderType)">Total：<span class="num">{{ subItem.totalQuantity }}</span> Pcs</div>
        <div class="time">Time：{{ subItem.localCreateTime }}</div>
      </div>
      <div :style="`color: ${subItem.fontColor}`">{{ subItem.status === 10 ? 'Completed' : subItem.status === 1 ? 'Pending Review' : subItem.status === -1 ? 'Rejected' : subItem.status === 0 ? 'Under Review' : '' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    toUrl (params) {
      this.$router.push(`/activity/pointsDetail?scanType=${params.orderType === 0 ? 'activityProduct' : 'activityUpload'}&scanId=${params.id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.history-record {
  height: 100%;
  font-size: 13px;
  .record-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0px;
    border-bottom: 1px solid #eee;
    .record-name {
      width: 266px;
      font-weight: bold;
    }
    .total-num {
      margin: 5px 0;
      .num {
        font-weight: bold;
        color: #307bff;
      }
    }
    .time {
      font-size: 12px;
      color: #aaaaaa;
    }
  }
}
</style>
